// extracted by mini-css-extract-plugin
export default {"icon":"LpSwipeQuestionSortIcon_icon__vmMgu","ascImage":"LpSwipeQuestionSortIcon_ascImage__U8u90","descImage":"LpSwipeQuestionSortIcon_descImage__MaL2V"};